import { render, staticRenderFns } from "./FmPageDemo.vue?vue&type=template&id=67e3de74&scoped=true&"
import script from "./FmPageDemo.vue?vue&type=script&lang=js&"
export * from "./FmPageDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3de74",
  null
  
)

export default component.exports